const DEFAULT_SITE_URL = 'https://fix.24x.co.th'

export const SITE_URL = (process.env.NEXT_PUBLIC_HOST || DEFAULT_SITE_URL)
  .trim()
  .replace(/\/+$/, '')
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/images/24fix-black-logo.png`

export const getCanonicalUrl = path => {
  if (!path || path === '/') {
    return SITE_URL
  }

  try {
    const parsedUrl = new URL(path, SITE_URL)
    const pathname = parsedUrl.pathname === '/' ? '' : parsedUrl.pathname.replace(/\/+$/, '')
    return `${SITE_URL}${pathname}`
  } catch (error) {
    const pathname = String(path).split(/[?#]/)[0].replace(/^\/+|\/+$/g, '')
    return pathname ? `${SITE_URL}/${pathname}` : SITE_URL
  }
}

export const getAbsoluteImageUrl = image => {
  if (!image) {
    return DEFAULT_OG_IMAGE
  }

  try {
    return new URL(image, SITE_URL).toString()
  } catch (error) {
    return DEFAULT_OG_IMAGE
  }
}
